/**
 * dalNumero.js — la pagina sa quando ci si arriva dal clic sul numero accanto
 * a una voce del menu (contatoreApre in navigazione/schermate.js: oggi
 * Pazienti e Fatture), per togliere la ricerca scritta.
 *
 * PERCHE' (Alex, 7/10/2026, risposta B7: «clic su "Da completare" con una
 * ricerca accesa toglie la ricerca: si'»). Il numero promette un elenco: chi
 * clicca «3» deve vedere le tre righe che il numero conta. La ricerca della
 * pagina sta nello stato della pagina e non nell'indirizzo, quindi chi era
 * gia' sulla pagina con una parola scritta arrivava all'elenco filtrato
 * RISTRETTO dalla ricerca: il numero diceva 3 e le righe erano una. Fino a
 * quel giorno la pagina teneva la ricerca e lo diceva (la riga del filtro
 * «Ristrette dalla ricerca»), scelta del 6/10 fatta prima della risposta.
 *
 * COME. Il collegamento del numero (components/Layout.jsx) porta nello stato
 * della navigazione il segno STATO_DAL_NUMERO; la pagina chiama useDalNumero()
 * durante il disegno, e quando risponde true svuota la sua ricerca. Durante
 * il disegno e non in un effetto: con un effetto la lettura dell'elenco
 * partirebbe prima con la ricerca vecchia e poi senza, cioe' due letture e due
 * righe nel registro degli accessi per un clic (la stessa ragione della pagina
 * che riparte dalla prima, PazientiListConsole: numeroPazienti.test.js).
 *
 * Vale solo per una navigazione fatta mentre la pagina e' montata e non per
 * un ritorno («Indietro», «Avanti»: tipo POP). Lo stato di una voce della
 * cronologia resta anche dopo: tornando indietro dal documento aperto in
 * Fatture alla voce nata dal numero, la ricerca scritta dopo il clic non deve
 * sparire. Al montaggio non serve: la pagina nasce con la ricerca vuota, e una
 * ricarica della voce nata dal numero (lo stato resta) non cambia niente.
 * Il segno non si consuma (come fa useAzione): non apre niente, e ripetuto non
 * fa danni.
 */
import { useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** La chiave dello stato della navigazione che porta il collegamento del numero. */
export const STATO_DAL_NUMERO = 'dalNumero';

/** Lo stato da dare al collegamento del numero. */
export const statoDalNumero = () => ({ [STATO_DAL_NUMERO]: true });

/**
 * true nel disegno della pagina che segue una navigazione dal numero (spinta o
 * sostituzione, non un ritorno), una volta per navigazione; false altrimenti.
 * Si chiama sempre, a ogni disegno (e' un hook).
 */
export default function useDalNumero() {
    const location = useLocation();
    const tipo = useNavigationType();
    const [vista, setVista] = useState(location.key);
    if (vista === location.key) return false;
    setVista(location.key);
    return tipo !== 'POP' && !!(location.state && location.state[STATO_DAL_NUMERO]);
}
